module.exports = __webpack_public_path__ + "img/2015_L.d26a3845.png";